export default __webpack_public_path__ + "assets/_Chapters/Karriere/Zitate/berufserfahrene-1.webp";